import classNames from 'classnames';
import VibeIcon from '../VibeIcon/VibeIcon';
import viCheck from '../../icons/viCheck';
import viSubtract from '../../icons/viSubtract';
import viInformation from '../../icons/viInformation';
import * as color from '../../sass/color.scss';
import './VibeCheckbox.scss';

function VibeCheckbox({
  className = null,
  label = null,
  name = null,
  tooltip = null,
  size = 16,
  color: checkboxColor = color.success,
  outline = false,
  rootStyle = {},
  style = {},
  indeterminate = false,
  disabled = false,
  checked = false,
  error = false,
  onChange = () => {},
}) {
  // Only use the custom color when checked
  let borderColor = color.manatee;

  if (checked) {
    borderColor = checkboxColor;
  } else if (error) {
    borderColor = color.lightGray;
  } else {
    borderColor = color.manatee;
  }

  /**
   * Get the background color for the checkbox
   */
  const getBackgroundColor = () => {
    // at top
    const backgroundColor = checked
      ? checkboxColor
      : 'transparent';

    if (disabled) {
      return 'light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3))';
    }

    if (outline) {
      return 'transparent';
    }

    return backgroundColor;
  };

  const onChangeCheckbox = () => {
    if (disabled) {
      return;
    }

    onChange({
      name,
      checked: !checked,
    });
  };

  return (
    <div
      className={classNames('VibeCheckbox', className, { disabled })}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        ...rootStyle,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: disabled
            ? 'default'
            : 'pointer',
        }}
        onClick={onChangeCheckbox}
      >
        <div
          className="check-item"
          style={{
            width: size,
            height: size,
            border: `1px solid ${borderColor}`,
            backgroundColor: getBackgroundColor(),
            ...style,
          }}
        >
          {checked && (
            <VibeIcon
              icon={indeterminate
                ? viSubtract
                : viCheck}
              color={outline
                ? checkboxColor
                : color.white}
              size={size - 5}
            />
          )}
        </div>

        {label && (
          <div
            style={{
              fontSize: 12,
            }}
          >
            {label}
          </div>
        )}
      </div>

      {tooltip && (
        <VibeIcon
          icon={viInformation}
          color={color.manatee}
          size={16}
          tooltip={tooltip}
          tooltipProps={{
            placement: 'right',
          }}
        />
      )}
    </div>
  );
}

export default VibeCheckbox;